import axios from 'axios'
import React, { FormEvent, useState } from 'react'
import ApiResponeMessageBox from '../../../components/apimessages/ApiResponeMessageBox'
import { apiResType } from '../../../helpers/types/global'

const TabAddBlogCategory = () => {
    const [category, setCategory] = useState('');
    const [loading, setLoading] = useState(false);
    const initialApiRes = {
        type: '',
        msg: ''
    }
    // TODO: make apiRes Type 
    const [apiRes, setApiRes] = useState(initialApiRes)
    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault()
        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_API}/blogCategory/create`, {
                category
            }).then(res => {
                setCategory('')
                setApiRes({
                    type: 'success',
                    msg: res.data.message
                })
                setTimeout(() => {
                    setApiRes(initialApiRes)
                }, 2000);
            })
        } catch (error: any) {
            if (error.response.data) {
                setApiRes({
                    type: 'errror',
                    msg: error.response.data.message
                })
                setTimeout(() => {
                    setApiRes(initialApiRes)
                }, 2000);
            }
        }
        setLoading(false)
    }
    return (
        <div>
            <div className="my-8">
                <form action="w-fit my-10 lg:mt-96" onSubmit={(e) => handleSubmit(e)}>
                    {apiRes.msg && <ApiResponeMessageBox type={apiRes.type} msg={apiRes.msg} />}

                    <div className="flex flex-col space-y-3 my-4">
                        <label htmlFor="category">Blog cateogry</label>
                        <input type="text" className='form-input inputs md:w-96' required placeholder='Enter a blog category....' value={category} onChange={(e) => setCategory(e.target.value)} />
                    </div>
                    <div className="flex space-x-2 my-4">
                        <input type="submit" className='btn btn-primary' value={loading ? 'Loading...' : 'Submit'} />
                    </div>

                </form>
            </div>
        </div>
    )
}

export default TabAddBlogCategory